module.exports = __webpack_public_path__ + "img/SmallGuns1.252715ba.png";